import { Badge, type BadgeTone } from '@ui';
import { useTranslation } from 'react-i18next';
import type { ColonyStatus } from '../api';

const tones: Record<ColonyStatus, BadgeTone> = {
  active: 'success',
  dead: 'danger',
  merged: 'neutral',
  sold: 'info',
  given_away: 'info',
};

export function StatusBadge({ status }: { status: ColonyStatus }) {
  const { t } = useTranslation();
  return (
    <Badge tone={tones[status]} size="sm" dot>
      {t(`apiary.status.${status}`)}
    </Badge>
  );
}
